import { useBackend } from "../../services";
import { ILabel } from "./interfaces";
import { useGetPaginatedAttributes } from "../attributes/useGetPaginatedAttributes";
import {
  IGetPaginatedAttributeProps,
  IPublicGetPaginatedAttributeProps
} from "../attributes/interfaces";
import { useCollectionManager } from "../collections/useCollectionManager";
import { PageSizeHelper } from "../../models/PageSizeHelper";
import { useUser } from "../session";
import { UserRole } from "../users";
import { DataStorage } from "../../models/DataStorage";

export const useGetLabels = (isPublic: boolean, setLoading: (loading: boolean) => void) => {
  const { get } = useBackend();
  const { getCurrentCollection } = useCollectionManager();
  const [currentUser] = useUser.useState();
  const getLabels = (parameters: IGetPaginatedAttributeProps) => get("labels", parameters);
  const getPublicLabels = (parameters: IPublicGetPaginatedAttributeProps) =>
    get("labels/shared/public", parameters);
  return useGetPaginatedAttributes<ILabel>(
    PageSizeHelper.labels(currentUser?.role ?? UserRole.common),
    isPublic ? getPublicLabels : getLabels,
    setLoading,
    DataStorage.labelStorage,
    isPublic,
    true,
    getCurrentCollection(isPublic)?.uuid
  );
};
